<template>
    <svg width="40" height="41" viewBox="0 0 40 41" xmlns="http://www.w3.org/2000/svg">
        <g fill="#043D89" fill-rule="nonzero">
            <path d="M2.233 29.311a1.297 1.297 0 0 0-.358.666L.025 39.22a1.308 1.308 0 0 0 1.541 1.538l9.239-1.847c.254-.051.487-.177.67-.361l20.682-20.683-9.238-9.24L2.233 29.31zM38.173 1.826a6.248 6.248 0 0 0-8.828 0l-3.463 3.463 8.828 8.829 3.463-3.464a6.245 6.245 0 0 0 0-8.828z"/>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'IconEdit',
};
</script>
